export const TARIFFS = ["START", "PRO", "PRO+", "GOLD"];

export const STAGES = {
  setup: { label: "Настроен", cls: "" },
  active: { label: "Пользуется", cls: "" },
  winning: { label: "Выигрывает", cls: "ok" },
  renewal: { label: "Продление", cls: "warn" },
  silent: { label: "Молчит", cls: "acc" },
  not_renewed: { label: "Не продлил", cls: "acc" },
};

export const FLAGS = [
  { key: "expiring", label: "Истекают ≤ 7 дн." },
  { key: "silent", label: "Молчат" },
  { key: "has_wins", label: "Есть победы" },
  { key: "expired", label: "Не продлили" },
  { key: "no_bin", label: "Без БИН (по лайкам)" },
  { key: "no_amo", label: "Без AmoCRM" },
];

export const ACCOUNT_TYPES = {
  client: "Клиент",
  tester: "Тестировщик",
  staff: "Сотрудник",
  partner: "Партнёр",
};

export const CLIENT_KINDS = {
  supplier: "Поставщик",
  newbie: "Новичок",
  distributor: "Дистрибьютор",
};

export const SOURCES = {
  ads: "Реклама (ads)",
  referral: "Рекомендация (referral)",
  niche_report: "Отчёт по нише (niche_report)",
  astana_hub: "Astana Hub (astana_hub)",
  other: "Другое (other)",
};

export const CHANNELS = {
  kaspi_pay: "Kaspi Pay",
  bcc: "BCC",
  promo: "Промо",
  admin: "Выдал администратор",
};

export function channelLabel(s) {
  if (!s?.channel) return "—";
  if (s.channel === "admin") return s.grantedByName ? `выдал ${s.grantedByName}` : CHANNELS.admin;
  return CHANNELS[s.channel] || s.channel;
}

export const PERIODS = {
  month: "месяц",
  quarter: "квартал",
  half_year: "полгода",
  year: "год",
};

// Тексты предупреждений пишет фронт, сервер отдаёт только коды
export const PASSPORT_WARNINGS = {
  no_bins: "БИН не указан — заявки и победы не считаются. Получить на звонке",
  unconfirmed_bins: "Не все БИН подтверждены клиентом",
};

export const GOSZAKUP_WARNINGS = {
  bins_incomplete: "Заявки ищутся не по всем БИН клиента — проверьте список БИН",
  distributor: "Сам не подаётся, лоты передаёт партнёрам. Смотрите вкладку «Активность»",
};

export const FEATURES = {
  marketplace_match: "Подбор товара на Kaspi (бета)",
  lot_priority: "Приоритет лотов",
  smart_search_v2: "Умный поиск v2",
};

export const LIKE_SOURCES = [
  { key: "extended", label: "Расширенный поиск", color: "#D93A74" },
  { key: "smart", label: "Умный поиск", color: "#F08A3C" },
  { key: "subscription", label: "Подписка КТРУ / уведомление", color: "#8E6BD1" },
  { key: "plain", label: "Обычный поиск", color: "#3B82F6" },
  { key: "other", label: "Другое", color: "#9C96A6" },
  { key: "unknown", label: "Неизвестно / старые", color: "#E7E2EC" },
];

export const TAB_OPENS = [
  { key: "ts_analysis", label: "Анализ ТС" },
  { key: "competitors", label: "Конкуренты" },
  { key: "similar_lots", label: "Аналогичные лоты" },
  { key: "customer", label: "Анализ заказчика" },
  { key: "product_match", label: "Подбор товара Kaspi" },
  { key: "marketplace", label: "Маркетплейсы" },
];

export const CHURN_REASONS = {
  not_used: "Не пользовался",
  no_lots: "Не нашёл лотов по своему товару",
  not_understood: "Не понял, как пользоваться анализом",
  expensive: "Дорого",
  not_bidding: "Не участвует сейчас",
  one_time: "Разовая задача",
  competitor: "Ушёл к конкуренту",
  other: "Другое",
};

export const TOUCH_CHANNELS = {
  call: "📞 Звонок",
  whatsapp: "💬 WhatsApp",
  meeting: "🤝 Встреча",
  other: "📝 Другое",
};

export const APPLICATION_RESULTS = {
  win: { label: "победа", cls: "ok" },
  lose: { label: "проигрыш", cls: "" },
  pending: { label: "на рассмотрении", cls: "warn" },
  rejected: { label: "отклонена", cls: "acc" },
};

export const DRAWER_TABS = [
  { key: "passport", label: "Паспорт" },
  { key: "subscription", label: "Подписка" },
  { key: "activity", label: "Активность" },
  { key: "goszakup", label: "Госзакупки" },
  { key: "niche", label: "Ниша" },
  { key: "work", label: "Работа" },
];
